import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

const httpOption = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Credentials': 'true',
    'Access-Control-Allow-Methods': 'GET,HEAD,OPTIONS,POST,PUT',
  }),
};

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
 
  url = environment.baseUrl+'/api/Dashboard';


  constructor(private http: HttpClient) {}

  getDatosPublicos(): Observable<any> {
    return this.http.post<any>(this.url + '/GetDatosPublicos', {}, httpOption);
  }

  getGraficaIngresoUltimos20Dias(): Observable<any> {
    return this.http.post<any>(this.url + '/GetGraficaIngresoUltimos20Dias', {}, httpOption);
  }
}
